












































import { Vue, Component, Watch, Emit } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import AMSCustomerDiscount from './../AMSDiscount.vue';
import moment from 'moment';
import { customerNoPermissionList, createDiscount } from '@/api/customer';
import Utils from '@/utils/utils';
interface ProductDiscounts {
  productId?: string;
  discountPrice?: number;
  status?: string;
  id?: string;
}

interface ProductCategoryDicounts {
  productCategoryId?: string;
  discountRate?: number;
  status?: string;
  id?: string;
}
interface Form {
  customerId?: string;
  productDiscounts?: Array<ProductDiscounts>;
  hiddenProductDiscounts?: Array<ProductDiscounts>;
  productCategoryDicounts?: Array<ProductCategoryDicounts>;
}

@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-discount': AMSCustomerDiscount,
  },
})
export default class CustomerDiscountCreate extends Vue {
  get valid() {
    if (
      this.form.customerId &&
      (this.form.productDiscounts!.filter((f: any) => {
        return f.id && f.discountPrice;
      }).length > 0 ||
        this.form.productCategoryDicounts!.filter((f: any) => {
          return f.id && f.discountRate;
        }).length > 0 ||this.form.hiddenProductDiscounts!.filter((f: any) => {
        return f.id && f.discountPrice;
      }).length > 0 )
    ) {
      return true;
    } else {
      return false;
    }
  }
  form: Form = {
    customerId: '',
    productDiscounts: [{}],
    productCategoryDicounts: [{}],
    hiddenProductDiscounts: [{}],
  };
  rules = {
    name: [],
  };
  breadItems = [
    {
      text: '客户管理',
      disabled: false,
      href: 'productManage',
    },
    {
      text: '客户折扣',
      disabled: false,
      href: '/customerDiscount',
    },
    {
      text: '新增折扣',
      disabled: true,
    },
  ];
  hasDisCount: Boolean = true;
  customerList: Array<any> = [];
  search: string = '';
  signDate: string = '';
  tabValue: number = 0;
  @Watch('search', { immediate: true, deep: true })
  onValueChange(newValue: any, oldValue: any) {
    newValue && this.getCustomerList(newValue);
  }
  @Watch('valid', { immediate: true, deep: true })
  onValidChange(newValue: any, oldValue: any) {
    this.hasDisCount = newValue;
  }
  autocomplete(val: any) {
    if (val) {
      this.form.customerId = val.id;
      this.signDate = moment(val.signDate).format('YYYY-MM-DD');
    }
  }

  getCustomerList(filter: string) {
    customerNoPermissionList({ isActive: true, filter: filter.split(' / ')[0], skipCount: 0, maxResultCount: 10 }).then((data: any) => {
      this.customerList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name + ' / ' + i.phone;
        return i;
      });
    });
  }

  discountChange(form: any) {
    this.form = Object.assign({}, this.form, form);
  }

  save() {
    let error = false;
    let filterHiddenProductDiscounts = this.form
      .hiddenProductDiscounts!.filter((f: any) => {
        return f.id;
      })
      .map((p: any) => {
        if (!p.discountPrice || Number(p.discountPrice) === 0) {
          error = true;
          this.hasDisCount = true;
          AppStore.ShowError('折扣价不能为0！');
          this.tabValue = 1;
        } else {
          this.hasDisCount = false;
        }
        console.log( p.discountPrice,this.hasDisCount,'hiddenProductDiscounts')
        return { productId: p.id, discountPrice: p.discountPrice };
      });
    let filterProductDiscounts = this.form
      .productDiscounts!.filter((f: any) => {
        return f.id;
      })
      .map((p: any) => {
        if (!p.discountPrice || Number(p.discountPrice) === 0) {
          error = true;
          this.hasDisCount = true;
          this.tabValue = 0;
          AppStore.ShowError('折扣价不能为0！');
        } else {
          this.hasDisCount = false;
        }
        return { productId: p.id, discountPrice: p.discountPrice };
      });
    let filterProductCategoryDicounts = this.form
      .productCategoryDicounts!.filter((f: any) => {
        return f.id;
      })
      .map((c: any) => {
        if (!c.discountRate) {
          error = true;
          this.hasDisCount = true;
          AppStore.ShowError('折扣率不能为空！');
          this.tabValue = 0;
        } else if (!c.discountRate || Number(c.discountRate) === 0) {
          error = true;
          this.hasDisCount = true;
          AppStore.ShowError('折扣率不能为零！');
          this.tabValue = 0;
        } else {
          this.hasDisCount = false;
        }
        return { productCategoryId: c.id, discountRate: c.discountRate };
      });
    if (error) return;
    let formData = Object.assign({}, this.form, {
      productDiscounts: filterProductDiscounts,
      hiddenProductDiscounts: filterHiddenProductDiscounts,
      productCategoryDicounts: filterProductCategoryDicounts,
    });
    createDiscount(this.form.customerId!.toString(), formData).then(() => {
      Utils.clearAllSearchPage(this.$route.name as string);
      this.$router.push({ name: 'customerDiscount' });
    }).catch(()=>{
      this.hasDisCount = true;
    })
  
  }
  goBack() {
    this.$router.go(-1);
  }
  changeTab(value: number) {
    this.tabValue = value;
  }
}
